import React from "react";

const NotAdminLayout = ({ children }) => {
  return <div className="layout__wrapper">{children}</div>;
};

export default NotAdminLayout;
